import React from 'react';
import { withTooltip, TOOLTIP_MODES } from 'moet-core';
import { Field as FieldCore, SwitchCheckbox, BorderlessDropdown as BorderlessDropdownCore, } from '@klarna/bubble-ui';
import { FieldType } from '@/bpc/mf-fields/types/Field.type';
import { ArrayField, EncryptedInput as EncryptedInputCore, Toggle as ToggleCore, } from '@/components';
import { BusinessSizeComponent } from '@/bpc/overrides/fields/BusinessSizeComponent';
import { CardsSelector } from '@/bpc/components/CardsSelector';
import { FIELD_OVERRIDES } from '@/bpc/overrides/fields';
import { FieldOverride } from '@/bpc/types/FieldOverride';
const Field = withTooltip(FieldCore);
const BorderlessDropdown = withTooltip(BorderlessDropdownCore);
const EncryptedInput = withTooltip(EncryptedInputCore);
// @ts-expect-error: FIXME
const Toggle = withTooltip(ToggleCore, { tooltipBottomOverride: '30px' });
export class OnboardingFieldComponent extends React.Component {
    constructor(props) {
        super(props);
        let startValue = props.value;
        // set booleans to false when there is no value yet and don't appear in the overwrite
        const isNotOverwritten = FIELD_OVERRIDES[props.field.absolutePath] !== FieldOverride.YesNo;
        if (props.field.type === FieldType.Boolean && isNotOverwritten && props.value === undefined) {
            startValue = false;
            // set the false as a default value on the payload so the button will be active
            props.onBlur(startValue);
        }
        this.state = {
            value: startValue,
            errorMessage: undefined,
        };
        this.onChange = this.onChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onChangeAndOnBlur = this.onChangeAndOnBlur.bind(this);
        this.onChangeArray = this.onChangeArray.bind(this);
    }
    componentDidUpdate(prevProps) {
        if (this.props.value !== prevProps.value) {
            this.setState({ value: this.props.value });
        }
    }
    onChange(value) {
        const validator = this.props.field.validator;
        const errorMessage = validator != null && !validator.callback(value) ? validator.errorMessage() : undefined;
        this.setState({ value, errorMessage });
        if (errorMessage == null) {
            this.props.onChange(value);
        }
    }
    onBlur() {
        const { errorMessage, value } = this.state;
        if (errorMessage == null) {
            this.props.onBlur(this.props.field.type === FieldType.Number ? Number(value) : value);
        }
    }
    onChangeAndOnBlur(value) {
        this.onChange(value);
        this.props.onBlur(value);
    }
    onChangeArray(newArray) {
        this.onChange(newArray);
        this.props.onBlur(newArray);
    }
    render() {
        var _a, _b;
        const { field, t, highlightMandatoryButEmptyFields } = this.props;
        let { value, errorMessage } = this.state;
        let label = t(field.label) || field.fallbackLabel;
        const isMandatory = field.mandatory();
        const isApplicable = field.applicable();
        const customConfiguration = field.customConfiguration ? field.customConfiguration() : undefined;
        const isDisabled = field.disabled();
        const isValueEmpty = value == null || value === '';
        const tooltipText = field.tooltipText
            ? t(field.tooltipText) || field.fallbackTooltip
            : undefined;
        // shouldn't add optional label to fields which became just inapplicable and fade out
        if (isApplicable && !isMandatory)
            label += ` (${t('products-fe.general.formFieldOptional')})`;
        if (isApplicable && isMandatory && highlightMandatoryButEmptyFields && isValueEmpty)
            errorMessage = label + `${t('products-fe.errors.mandatoryField')}`;
        if (FIELD_OVERRIDES.hasOwnProperty(field.absolutePath)) {
            switch (FIELD_OVERRIDES[field.absolutePath]) {
                case FieldOverride.YesNo:
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    return (React.createElement(Toggle, { label: field.absolutePath === 'business_information.should_auto_capture_orders'
                            ? label
                            : null, 
                        // @ts-expect-error: FIXME
                        tooltipText: tooltipText, tooltipMode: TOOLTIP_MODES.ICON, toggleValue: value, toggleOnChange: this.onChangeAndOnBlur, 
                        // @ts-expect-error: FIXME
                        error: errorMessage }));
                case FieldOverride.BusinessSizeComponent:
                    return (React.createElement(BusinessSizeComponent, Object.assign({ value: value, onChange: this.onChangeAndOnBlur, t: t, error: errorMessage }, customConfiguration)));
                case FieldOverride.BusinessConcepts:
                    return (React.createElement(CardsSelector, { value: value, onChange: this.onChangeAndOnBlur, options: field === null || field === void 0 ? void 0 : field.enumOptions(), error: errorMessage, showErrorOnTop: !isValueEmpty }));
            }
        }
        else if (field.type === FieldType.Boolean) {
            return (
            // @ts-expect-error: FIXME
            React.createElement(SwitchCheckbox, { checked: value, onChange: this.onChangeAndOnBlur, disabled: isDisabled }, label));
        }
        else if (field.type === FieldType.Enum) {
            const options = OnboardingFieldComponent.enumOptionsToBubbleUi(t, field.enumOptions());
            return (React.createElement(BorderlessDropdown, { label: errorMessage || label, error: errorMessage != null, 
                // @ts-expect-error: FIXME
                value: value, 
                // @ts-expect-error: FIXME
                tooltipText: tooltipText, onChange: this.onChangeAndOnBlur, options: [{ key: '', label: 'Pick one!', disabled: true, hidden: true }, ...options], disabled: isDisabled }));
        }
        else if (field.type === FieldType.ArrayOfEnum) {
            return (React.createElement(ArrayField, { label: label, max: ((_a = field.enumLimits) === null || _a === void 0 ? void 0 : _a.max) || Number.MAX_SAFE_INTEGER, min: ((_b = field.enumLimits) === null || _b === void 0 ? void 0 : _b.min) || 0, options: OnboardingFieldComponent.enumOptionsToBubbleUiForArrayField(t, field.enumOptions()), onChange: this.onChangeArray, value: value, disabled: isDisabled }));
        }
        else if (field.type === FieldType.Date) {
            return (React.createElement(Field
            // @ts-expect-error: FIXME
            , { 
                // @ts-expect-error: FIXME
                value: value, label: errorMessage || label, 
                // @ts-expect-error: FIXME
                tooltipText: tooltipText, error: errorMessage != null, onChange: this.onChange, 
                // @ts-expect-error: FIXME
                onBlur: this.onBlur, isUnderlined: true, type: "date", disabled: isDisabled }));
        }
        else if (field.type === FieldType.EncryptedString) {
            return (React.createElement(EncryptedInput
            // @ts-expect-error: FIXME
            , { 
                // @ts-expect-error: FIXME
                value: value, 
                // @ts-expect-error: FIXME
                tooltipText: tooltipText, label: errorMessage || label, error: errorMessage != null, onChange: this.onChange, 
                // @ts-expect-error: FIXME
                onBlur: this.onBlur, isUnderlined: true, disabled: isDisabled }));
        }
        else {
            const type = { [FieldType.String]: 'text', [FieldType.Number]: 'number' }[field.type];
            return (React.createElement(Field
            // @ts-expect-error: FIXME
            , { 
                // @ts-expect-error: FIXME
                value: value, 
                // @ts-expect-error: FIXME
                tooltipText: tooltipText, label: errorMessage || label, error: errorMessage != null, onChange: this.onChange, 
                // @ts-expect-error: FIXME
                onBlur: this.onBlur, isUnderlined: true, type: type, disabled: isDisabled }));
        }
    }
    static sortByLabel(a, b) {
        const x = a.label.toLowerCase();
        const y = b.label.toLowerCase();
        if (x > y) {
            return 1;
        }
        if (x < y) {
            return -1;
        }
        return 0;
    }
    static enumOptionsToBubbleUi(translator, enumOptions) {
        return enumOptions
            .map(o => ({
            key: o.key,
            label: translator(o.label) || o.fallbackLabel,
        }))
            .sort(OnboardingFieldComponent.sortByLabel);
    }
    static enumOptionsToBubbleUiForArrayField(translator, enumOptions) {
        return enumOptions
            .map(o => ({
            key: o.key,
            label: translator(o.label) || o.fallbackLabel,
        }))
            .sort(OnboardingFieldComponent.sortByLabel);
    }
}
